import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableEditRow, TableEditColumn, TableFilterRow, TableColumnVisibility, TableFixedColumns } from "@devexpress/dx-react-grid-material-ui";
import { QueryString, Create, Update, Remove, ExportXlsx, TIMER_FILTER, APPNAME_AUTOMACAOCARGAHIAE } from "../utils/react_grid_utils";
import { editColumnMessages } from "../utils/react_grid_edit_command_localization";
import Import from "../utils/import";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import Header from "../Header";
import { NomeEmailTypeProvider } from "../utils/react_grid_nome_email_column";
import { NomeD2iCirurgiaoTypeProvider } from "../utils/react_grid_nome_d2i_cirurgiao_column";

const getRowId = (row) => row.id;
const api_resource = "carga-hiae/de-para-cirurgioes";

export default function DeParaCirurgioesHIAETable() {
  const alert = useAlert();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(10);
  const [totalItens, setTotalItens] = useState(0);
  const [rows, setRows] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "id", width: 60 },
    { columnName: "nome_email", width: 350 },
    { columnName: "nome_d2i", width: 350 },
  ]);
  const [filteringStateColumnExtensions] = useState([]);
  const [defaultHiddenColumnNames] = useState(["id"]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filtersApi, setFiltersApi] = useState([]);

  function get(page, filters) {
    const queryString = QueryString(page, pageSize, filters);
    http.get(api_resource + queryString).then(
      (response) => {
        addRows(response?.data?.data);
        setTotalItens(Number(response?.data?.total) || 0);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function addRows(rows) {
    setRows(rows);
  }

  useEffect(() => {
    get(0, []);
  }, []);

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFiltersApi(filters);

    setTimer(
      setTimeout(function () {
        get(pageIndex, filters);
      }, TIMER_FILTER)
    );
  }

  function handlePage(page) {
    setPageIndex(page);
    get(page, filtersApi);
  }

  const changeAddedRows = (value) => {
    const initialized = value.map((row) => (Object.keys(row).length ? row : {}));
    setAddedRows(initialized);
  };

  const commitChanges = ({ added, changed, deleted }) => {
    if (added) {
      Create(api_resource, added[0], alert).then((response) => {
        if (response && response.data) {
          get(pageIndex, filtersApi);
        }
      });
    }
    if (changed) {
      const changedRows = rows.map((row) => (changed[row.id] ? { ...row, ...changed[row.id] } : row));
      const item = changedRows.find((row) => changed[row.id]);

      Update(api_resource, item, alert).then((response) => {
        if (response) {
          get(pageIndex, filtersApi);
        }
      });
    }
    if (deleted) {
      var confirmado = window.confirm("Confirma a exclusão?");
      if (confirmado === true) {
        Remove(api_resource, deleted[0], alert).then((response) => {
          if (response) {
            get(pageIndex, filtersApi);
          }
        });
      }
    }
  };

  var columns = [
    { name: "id", title: "ID" },
    { name: "nome_email", title: "Nome Email" },
    { name: "nome_d2i", title: "Nome D2i" },
  ];

  const [nomeEmailColumns] = useState(["nome_email"]);
  const [nomeD2iColumns] = useState(["nome_d2i"]);

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>De-Para Cirurgiões HIAE</h2>
          </div>
          <div className="col-lg-2">
            <button className="btn btn-primary btn-sm" style={{ marginTop: "20px" }} type="button" onClick={() => ExportXlsx(api_resource, alert)}>
              Exportar
            </button>
            <Import api_resource={api_resource} alert={alert} appname={APPNAME_AUTOMACAOCARGAHIAE} excluir={true} onFinish={() => get(0, [])} />
          </div>
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">
                  <Grid rows={rows} columns={columns} getRowId={getRowId}>
                    <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={handlePage} />
                    <EditingState editingRowIds={editingRowIds} onEditingRowIdsChange={setEditingRowIds} rowChanges={rowChanges} onRowChangesChange={setRowChanges} addedRows={addedRows} onAddedRowsChange={changeAddedRows} onCommitChanges={commitChanges} columnExtensions={tableColumnExtensions} />
                    <FilteringState onFiltersChange={handleFilters} columnExtensions={filteringStateColumnExtensions}/>
                    <NomeEmailTypeProvider for={nomeEmailColumns} />
                    <NomeD2iCirurgiaoTypeProvider for={nomeD2iColumns} />
                    <Table columnExtensions={tableColumnExtensions} />
                    <TableHeaderRow />
                    <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                    <TableEditRow />
                    {authenticatedUserContext.allow_edit(APPNAME_AUTOMACAOCARGAHIAE) === true ? <TableEditColumn showAddCommand={!addedRows.length} showEditCommand showDeleteCommand messages={editColumnMessages} /> : <></>}
                    <CustomPaging totalCount={totalItens} />
                    <PagingPanel />
                    <TableFilterRow />
                    <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
